import React from 'react';
import { faTimes, faTrash } from '@fortawesome/free-solid-svg-icons';
import DeleteConfirmationModal from 'components/modals/DeleteConfirmationModal';
import useConfirmation from 'hooks/useConfirmation';
import IconButtonWithTooltip from './IconButtonWithTooltip';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ConfirmationModal = ({ isOpen, onConfirm, onCancel, messageTranslationKey, icon, actionTranslationKey }) => {
    const { t } = useTranslation();
    return (
      <Modal isOpen={isOpen} toggle={onCancel}>
        <ModalHeader toggle={onCancel}>{t(actionTranslationKey)}</ModalHeader>
        <ModalBody>
          {t(messageTranslationKey)}
        </ModalBody>
        <ModalFooter className="mb-3" style={{ justifyContent: 'center' }}>
          <IconButtonWithTooltip translationId={actionTranslationKey} icon={icon} onClick={onConfirm} type="Button" size="sm" color="danger" className="me-2" />
          <IconButtonWithTooltip translationId={"Cancel"} icon={faTimes} onClick={onCancel} type="Button" size="sm" color="secondary" className="btn" />
        </ModalFooter>
      </Modal>
    );
};

const ConfirmedButton = ({translationId, messageTranslationKey, icon, onClick, type, size, actionTranslationKey, color, modalIcon}) => {
    const confirmation = useConfirmation(onClick);
    return (
        <>
            <ConfirmationModal 
                {...confirmation.modalProps} 
                messageTranslationKey={messageTranslationKey}
                icon={modalIcon || icon} 
                actionTranslationKey={translationId} 
            />
            <IconButtonWithTooltip 
                translationId={translationId} 
                icon={icon} 
                onClick={() => confirmation.requestConfirmation()} 
                type={type} 
                size={size}
                color={color}
            />
        </>
    );
};

export default ConfirmedButton;
